<template>
  <div class="dashboard-layout">
    <el-menu :default-active="$route.name" class="el-menu-vertical">
      <el-menu-item
          v-if="['ADMIN_PREFEITURA', 'PREFEITURA'].includes(role)"
          :index="'/dashboard/prefeitura'"
          @click="navigate('/dashboard/prefeitura')"
      >
        Prefeitura
      </el-menu-item>
      <el-menu-item
          v-if="['ADMIN_CEMITERIO', 'CEMITERIO'].includes(role)"
          :index="'/dashboard/cemiterio'"
          @click="navigate('/dashboard/cemiterio')"
      >
        Cemetery
      </el-menu-item>
      <el-menu-item
          v-if="['ADMIN_FUNERARIA', 'FUNERARIA'].includes(role)"
          :index="'/dashboard/funeraria'"
          @click="navigate('/dashboard/funeraria')"
      >
        Funeral Home
      </el-menu-item>
    </el-menu>
    <router-view />
  </div>
</template>

<script>
import { useUserStore } from "@/stores/user";

export default {
  setup() {
    const userStore = useUserStore();

    const navigate = (path) => {
      window.location.href = path;
    };

    return {
      role: userStore.role,
      navigate,
    };
  },
};
</script>

<style scoped>
.dashboard-layout {
  display: flex;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  padding: 12px 24px;
  gap: 16px;
  overflow-x: hidden; /* Prevent horizontal scrollbar */
}
.el-menu-vertical {
  width: 20px; /* 10% of 200px */
  min-width: 20px;
  max-width: 22px;
}
</style>
